module.exports = "/_next/static/images/ManageQualityData@2x-85ab4c4d317e90dd43a4cf13a99be6a0.webp";